// extracted by mini-css-extract-plugin
module.exports = {"VideoPlayback":"VideoPlayback_VideoPlayback__3O2xE","fadein":"VideoPlayback_fadein__36idq"};